import { Layout } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';
import { ServiceType } from '../../modules/entities/Entities';
import { SelectFieldOption } from '../../modules/forms/fields/SelectFieldOption';
import { ServiceRequestPageViewProps } from './ServiceRequestPageViewProps';
import { Form } from '../../modules/forms/Form';
import { FieldsGroup } from '../../modules/common-components/FieldsGroup';
import { TextInputField } from '../../modules/forms/fields/TextInputField';
import { SelectField } from '../../modules/forms/fields/SelectField';
import { TextAreaField } from '../../modules/forms/fields/TextAreaField';
import { maxMileageLength, sanitizeMileage } from '../../utils/MileageUtils';

function createServiceTypeOptions(serviceTypes: ServiceType[]): SelectFieldOption[] {
  return serviceTypes.map((serviceType) => ({
    label: serviceType.name,
    value: serviceType.name,
    key: serviceType.name,
  }));
}

export function ServiceRequestPageVwView({
  initialFormData,
  formRef,
  formSchema,
  vehicleServiceHistory,
  serviceTypes,
}: ServiceRequestPageViewProps): ReactElement {
  const serviceTypeOptions = serviceTypes ? createServiceTypeOptions(serviceTypes) : [];

  return (
    <Layout allowOverflowingContent>
      <Form schema={formSchema} defaultValues={initialFormData} ref={formRef}>
        <FieldsGroup>
          <TextInputField
            name="mileage"
            label="Your latest mileage on record. Please, update current mileage"
            type="numeric"
            sanitize={sanitizeMileage}
            rules={{ min: vehicleServiceHistory?.mileage ?? 0, required: true, maxLength: maxMileageLength }}
            isFloating
            autoFocus
          />
          <SelectField
            name="serviceTypeName"
            label="Your service Km or repair"
            options={serviceTypeOptions}
            required
          />
          <TextAreaField name="serviceCommentary" label="Additional notes" rules={{ maxLength: 250 }} isFloating />
        </FieldsGroup>
      </Form>
    </Layout>
  );
}
